import React from 'react';
import { ProductivityHub } from '../../components/dashboards/ProductivityHub';

/**
 * Page conteneur pour le Google Hub (Productivity Hub)
 * Cette page intègre la gestion des emails et du calendrier Google
 */
export const ProductivityHubPage: React.FC = () => {
  return <ProductivityHub />;
};

export default ProductivityHubPage;
